import ApiClientUserMixin from './ApiClientUserMixin.js';
import axios from 'axios';
import Errors from './../../errors.js'

export default {
  mixins: [ApiClientUserMixin],
  props: {
    invalidDocuments : {
      type: Array,
      required: false,
      default: () => []
    },  
    skippedDocuments : {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      minutesLeftToUpload: process.env.VUE_APP_EXPIRATION_MINUTES,
      showTimer: false,
      processingTimerId: null,
      isLoading: false,
      documentsData: [
        { 
          title: "Паспорт гражданина",
           files: [], 
           isValidating: false, 
           isValid: null,
           type: 'Passport',
           id: null
        },
        {
          title: "Страховое свидетельство государственного пенсионного страхования",
          files: [],
          isValidating: false, 
          isValid: null,
          type: 'InsuranceCertificate',
          id: null
        },
        {
          title: "Свидетельство о присвоении ИНН",
          files: [],
          isValidating: false, 
          isValid: null,
          type: 'Inn',
          id: null
        },
        {
          title: "Документы воинского учета для военнообязанных и лиц, подлежащих призыву на военную службу",
          files: [],
          isLiableForMilitaryService: true,
          isValidating: false, 
          isValid: null,
          type: 'WarTicket',
          id: null
        },
        {
          title: "Документ об образовании и(или) о квалификации или наличии специальных знаний",
          files: [],
          educationLevel: 0,
          isValidating: false, 
          isValid: null,
          type: 'EducationDocs',
          id: null
        },
      ],
      selectedDocumentIndex: 0,
      isReadyToSend: false
    };
  },
  computed: {
    expirationMinutes() {
      return process.env.VUE_APP_EXPIRATION_MINUTES;
    },
    timerMessage() {
      let minuteUnits = this.minutesLeftToUpload % 10;
      let minutesWord = "МИНУТ";
      let leftWord = "ОСТАЛОСЬ";
      if (minuteUnits > 1 && minuteUnits <= 4) minutesWord = "МИНУТЫ";
      if (minuteUnits === 1) {
        minutesWord = "МИНУТА";
        leftWord = "ОСТАЛАСЬ";
      }
      return `${leftWord} ${this.minutesLeftToUpload} ${minutesWord}`;
    },
    currentDocumentData() {
      return this.documentsData[this.selectedDocumentIndex];
    },
    isLiableForMilitaryService() {
      return this.documentsData.find(dd => dd.type === 'WarTicket').isLiableForMilitaryService === true;
    }
  },
  mounted() {
    let component = this;
    window.addEventListener("beforeunload", this.checkBeforeExit);
    this.isLoading = true;
    axios.post(`${this.baseUrl}/packages/${this.packageId}/reset`,
      null,
      { headers: { authorization: this.token } })
      .catch(() => component.$emit("change-page", "error", Errors.InternalServerError))
      .finally(() => component.isLoading = false);
  },
  methods: {
    checkBeforeExit (e) {
      if (this.documentsData.find(dd => dd.id !== null) === undefined)
        return;
      e.cancelBubble = true;
      e.returnValue = 'Все введённые данные будут утеряны. Вы уверены, что хотите покинуть страницу?';
    },
    startProcessingTimer() {
      if (this.showTimer) return;
      this.showTimer = true;
      this.processingTimerId = setInterval(() => {
        this.minutesLeftToUpload--;
        if (this.minutesLeftToUpload === 0) {
          window.removeEventListener("beforeunload", this.checkBeforeExit);
          window.location.reload();
        }
      }, this.expirationMinutes * 1000);
      this.$refs.timerNotificationModalWindow.showed = true;
    },
    generateInvalidDocuments() {
      this.invalidDocuments.splice(0, this.invalidDocuments.length);
      let component = this;
      this.documentsData.forEach(document => {

        let isMissing = document.files.length === 0;
        if (!isMissing) {

          if (document.type === 'WarTicket' && this.isLiableForMilitaryService === false) 
            return;
          
          if (document.isValid) 
            return;
        }

        if (component.skippedDocuments.find(skipped => skipped.type === document.type)) 
          return;

        component.invalidDocuments.push({           
          type: document.type,
          title: document.title, 
          canSkip: !isMissing || document.type === 'Inn' || (document.type === 'WarTicket' && this.isLiableForMilitaryService === false),
          isMissing
        });
      });
    },
    async sendDocuments() {

      this.generateInvalidDocuments();

      if (this.invalidDocuments.length > 0) {
        this.$refs.invalidDocumentsModalWindow.showed = true;
        return;
      }

      if (this.isLiableForMilitaryService === false) 
        await this.transferMilitaryDocuments();

      this.isLoading = true;
      let component = this;

      let sendResult = await axios.post(`${this.baseUrl}/packages/${this.packageId}/start`,
        null, { headers: { authorization: this.token } })
        .catch(() => component.error(Errors.SendingError));
        
      this.isLoading = false;
      window.removeEventListener("beforeunload", this.checkBeforeExit);
        
      if (sendResult.status > 199 && sendResult.status < 300)
        this.$emit("change-page", "success");
      else 
        this.error(Errors.SendingError)
    },
    async transferMilitaryDocuments() {
      
      let warDoc = this.documentsData.find(dd => dd.type === "WarTicket");
      if (warDoc.id === null)
        return;
      
      this.isLoading = true;
      let deleteResult = await axios.delete(`${this.baseUrl}/documents/${warDoc.id}`, { headers: { authorization: this.token }})
        .catch(() => component.error(Errors.SendingError));
      if (deleteResult.status > 299 || deleteResult.status < 200) {
        this.error(Errors.SendingError);
        return;
      }
      
      let component = this;
      let passport = this.documentsData.find(dd => dd.type === "Passport");
      let patchResult = await axios.patch(`${this.baseUrl}/documents/${passport.id}`, {
        docType: passport.type,
        newFiles: warDoc.files.map(file => {
          return {
            fileName: file.name,
            base64Content: file.data.split(",").slice(-1)[0]
          }
        }),
        data: this.getSpecificData(passport)
      }, { headers: { authorization: component.token } })
        .catch(() => component.error(Errors.SendingError));
      
      this.isLoading = false;
      if (patchResult.status > 299)
          this.error(Errors.SendingError);
    },
    handleSkipInvalidDocumentClick() {
      this.$refs.invalidDocumentsModalWindow.showed = false;
      this.skippedDocuments.push(this.invalidDocuments[0]);
      this.sendDocuments();
    },
    handleUploadInvalidDocumentClick() {
      let invalidDocument = this.invalidDocuments[0];
      this.selectedDocumentIndex = this.documentsData.findIndex(dd => dd.type === invalidDocument.type);
      this.$refs.invalidDocumentsModalWindow.showed = false;
      let component = this;
      setTimeout(() => {
        component.$refs.uploadingForm.openFileSelector();
      }, 300);
    },
    handleCancelSendingClick() {
      this.$refs.invalidDocumentsModalWindow.showed = false;
      this.invalidDocuments.splice(0, this.invalidDocuments.length);
    },
    selectNextStep() {
      if (this.documentsData.length - 1 > this.selectedDocumentIndex)
        this.selectedDocumentIndex++;
      else {
        let notReadyIndex = this.documentsData.findIndex(dd => 
          dd.files.length === 0 && 
          (dd.type !== 'WarTicket' || dd.isLiableForMilitaryService === true));
        if (notReadyIndex === -1) {
          this.isReadyToSend = true;
        }
        else this.selectedDocumentIndex = notReadyIndex;
      }
    },
    async handleImagesDeleted(files) {
      let component = this;
      this.isLoading = true;
      files.forEach(async file => {
        await axios.delete(`${component.baseUrl}/images/${file.id}`,
          { headers: { authorization: this.token } })
          .catch(error => alert("Произошла ошибка при попытке удалить изображения из пакета: " + error.message));
      });

      component.isLoading = false;
      component.validate(this.currentDocumentData);
    },
    handleFilesUploaded(type, files = []) {

      if (files.length === 0)
        return;

      let currentDocumentData = this.documentsData.find(dd => dd.type === type);
      this.isLoading = true;

      if (currentDocumentData.id > 0) {
        this.patchDocument(currentDocumentData, files.filter(file => !file.id))
      }
      else {
        this.putDocument(currentDocumentData, files);
      }
    },
    patchCurrentDocument(newFiles = []) {
      this.patchDocument(this.currentDocumentData, newFiles);
    },
    async patchDocument(document, newFiles = []) {

      if (document.id === null) {
        return;
      }

      this.isLoading = true;
      let component = this;

      let result = await axios.patch(`${this.baseUrl}/documents/${document.id}`, {
        docType: document.type,
        newFiles: Array.from(newFiles).map(file => { 
          return {
            fileName: file.name,
            base64Content: file.data.split(",").slice(-1)[0]
          }
        }),
        data: this.getSpecificData(document)
      }, { headers: { authorization: this.token } })
      .catch(() => component.error(Errors.InternalServerError));

      this.isLoading = false;

      if (result.status > 299 || result.status < 200) {
        this.error(Errors.InternalServerError);
      }
      else 
        this.processUploadingResult(document, newFiles, result);
    },
    async putDocument(document, files) {
      
      this.isLoading = true;
      let component = this;

      let result = await axios.put(`${this.baseUrl}/documents`, {
        packageId: this.packageId,
        docType: document.type,
        files: files.map(file => {
          return {
            fileName: file.name,
            base64Content: file.data.split(",").slice(-1)[0]
          }
        }),
        data: this.getSpecificData(document)
      }, { headers: { authorization: this.token } })
      .catch(() => {
        component.error(Errors.InternalServerError);
      });

      this.isLoading = false;

      if (result.status > 299) {
        this.error(Errors.InternalServerError);
      }
      else 
        this.processUploadingResult(document, files, result);
    },
    processUploadingResult(document, files, result){

      let component = this;
      let documentId = result.data.id;
      let pdfs = [];

      result.data.files.forEach(file => {
        let localFile = files.find(f => file.fileName === f.name);
        let localFileIndex = document.files.findIndex(f => file.fileName === f.name);
        if (!localFile.isPdf) 
          localFile.id = file.id;
        else {
          let pdf = pdfs.find(pdf => pdf.index === localFileIndex);
          if (pdf === undefined) {
            pdf = {
              index: localFileIndex,
              images: []
            };
            pdfs.push(pdf);
          }
          pdf.images.push({
            id: file.id,
            name: file.fileName,
            data: '',
            isPdf: false,
            isLoading: false
          });
        }
      });

      document.id = documentId;

      if (pdfs.length === 0) {
        if (files.length > 0 && document.isValid !== true)
          component.validate(document);
      }
      else 
        pdfs.forEach(pdf => component.loadPdf(document, pdf.index, pdf.images));
    },
    loadPdf(document, pdfFileIndex, images) {
      document.files.splice(pdfFileIndex, 1);
      for (var i = 0; i < images.length; i++)
        document.files.splice(pdfFileIndex + i, 0, images[i]);
      this.$refs.uploadingForm.loadPdf(images);
    },
    handlePdfRendered(images){

      let document = this.documentsData.find(dd => 
        dd.files.find(f => 
          images.find(image => image.id === f.id) !== undefined) !== undefined);
      if (document.files.find(f => f.isUploading === true))
        return;

      this.validate(document);
    },
    getSpecificData(document){
      if (document.type !== "EducationDocs")
        return null;

      let level = undefined;
      switch (document.educationLevel){
        case 0:
          level = "High";
          break;
        case 1:
              level = "MiddleProfessional";
          break;
        case 2:
              level = "StartProfessional";
          break;
        case 3:
              level = "MiddleCommon";
          break;
        case 4:
              level = "Common";
          break;
      }

      return {
        educationLevel: level
      };
    },
    validate(document){

      document.isValid = null;

      if (document.files.length === 0)
        return;
        
      document.isValidating = true;

      axios.post(`${this.baseUrl}/documents/${document.id}/validate`,
        null,
        { headers: { authorization: this.token } })
        .then(result => {
          document.isValid = result.data.isValid === true;
        })
        .finally(() => document.isValidating = false);
    },
    startValidation(document){

      let component = this;
      axios.post(`${this.baseUrl}/documents/${document.id}/startValidation`,
        null,
        { headers: { authorization: this.token } })
        .then(() => {
          
          if (document.isValidating)
            return;
            
          document.isValid = null;
          document.isValidating = true;

          component.handleActiveValidation(document.id);
        });
    },
    handleActiveValidation(documentId) {
      
      let component = this;
      let validationCheckInterval = setInterval(() => {

        axios.get(`${this.baseUrl}/packages/${component.packageId}`,
          { headers: { authorization: this.token } })
          .then(result => {

            let document = result.data.documents.find(d => d.id === documentId);
            if (document === undefined) 
              return;

            let componentDocument = component.documentsData.find(dd => dd.id === documentId);
            if (componentDocument === undefined) {
              window.clearInterval(validationCheckInterval);
              return;
            }

            var hasErrors = false;
            switch (document.documentState) {

              case 'ValidatedWithWarnings':
                hasErrors = true;
                break;

              case 'Validated':
                hasErrors = false;
                break;

              default:
                return;
            }

            window.clearInterval(validationCheckInterval);
            componentDocument.isValidating = false;
            componentDocument.isValid = !hasErrors;
          })
          .catch(() => window.clearInterval(validationCheckInterval));

      }, 1000);
    },
    error(error) {
      this.isLoading = false;
      this.$emit("change-page", "error", error);
      window.removeEventListener("beforeunload", this.checkBeforeExit);
    }
  },
}